import { useQuery } from "react-query";
import * as ajaxEndpoints from "../../../api/ajax-endpoints";
import { getData } from "../../../newApis/dotNetApiMethods";
import { IResponse } from "../../../interfaces/response";

export interface IAdminUserDetail {
  id: number;
  lastLogin: string | null;
  firstName: string;
  lastName: string;
  dateJoined: string;
  phone: string;
  userType: string;
  email: string;
  emailConfirmed: number;
  address: string;
  ssoUserId: string;
  createdDate: string;
  lastUpdate: string;
  phoneNumber: string;
  phoneNumberConfirmed: boolean;
  twoFactorEnabled: boolean;
  lockoutEndDateUtc: string | null;
  lockoutEnabled: boolean;
  accessFailedCount: number;
  ssoId: string;
  userName: string;
  isGoogleAuthenticatorEnabled: boolean;
  isLocked: boolean;
  unlockStatusText: string;
  userLockDetails: {
    id: number;
    userId: string;
    reasonId: number;
    additionalInfo: string | null;
    operatorId: string;
    createdAt: string;
    userName: string;
    operatorName: string;
    reason: string;
    lockType: string;
  } | null;
}

const getAdminUser = async (ssoUserId: string): Promise<IAdminUserDetail> => {
  const { data } = await getData(
    `${ajaxEndpoints.GET_ADMIN_USER}?ssoUserId=${ssoUserId}`,
  );
  return data?.data;
};

export default function useGetAdminUser(ssoUserId: string | null | undefined) {
  return useQuery<IAdminUserDetail, Error>(
    [ssoUserId, "getAdminUser"],
    getAdminUser,
    {
      enabled: !!ssoUserId,
      refetchOnWindowFocus: false,
    },
  );
}
